export const FIELDS = {
  NICKNAME: 'nickname',
  NICKNAME_MATCHES: 'nicknameMatches',
  NAME: 'name',
  EMAIL: 'email',
  ITN: 'itn'
}
